import { createUseRecipeHook, RecipeVariants } from '@theme';
import * as style from './TxtHighlight.css';

export const useTxtHighlightStyle = createUseRecipeHook(style.root);
export type TxtHighlightStyleProps = RecipeVariants<typeof style.root>;
